<template>
  <div class="introduction">

    <p class="intro">Introducing the SIMPAS-applied Solutions&trade; Farm Benefit Tool. It’s an interactive way to evaluate your potential in using SIMPAS™ technology to prescriptively apply multiple products in-furrow simultaneously, to manage problem areas in the field without having to sacrifice potential yield.</p>
    <h3>
        The tool is designed to:
    </h3>
    <ul>
    <li><span>Allow users to input custom information about their farm (acres, problem areas, etc.).</span></li>
    <li><span>Show the annual net value of using a SIMPAS-applied Solutions approach vs. a whole field application.</span></li>
    <li><span>Help users understand the costs and benefits of a prescriptive application.</span></li>
    </ul>
    <p>Try it today and see exactly why you should invest in your field potential!</p>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  mounted: function() {
      setTimeout(function(){
        document.querySelector('.instructions').style.display = "none";
        document.querySelector('#app').classList.remove('show-forms');
        document.querySelector('#app').classList.add('show-home');
      }, 10);
  }
}
</script>
